import React, {PureComponent} from "react"
import styled from "styled-components"

import id from "@irati/utils/id"
import {CompanyValue} from "@irati/companyvalues/types"
import {injectIntl, InjectIntl, FormattedMessage} from "@irati/utils/lang"
import Tooltip, {Tip} from "@irati-web/recognition/src/components/shared/Tooltip"
import {maxLengthString} from "@irati/utils/string"

import mainTheme from "@irati/ui/src/global/theme"
import CompanyValueTag from "./Tag"

const MAX_TOOLTIP_LIMIT = 10

const FlexWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: inherit;
  overflow: hidden;
  div:last-child {
    margin-right: 0px;
  }
`

const StyledDiv = styled.div`
  display: inherit;
  flex-wrap: inherit;
  justify-content: inherit;
  max-width: 100%;
  overflow: hidden;
  gap: ${mainTheme.spacing.half};
`

const StyledTooltipContent = styled.div`
  margin-bottom: 1px;
  text-transform: initial;
`

interface Props extends InjectIntl {
  companyValues: {
    results: CompanyValue[]
  }
  limit?: number
}

class CompanyValues extends PureComponent<Props> {
  static defaultProps = {
    companyValues: undefined,
    limit: 9999
  }

  getTooltip = () => {
    const {companyValues, limit} = this.props
    if (companyValues.results.length <= limit) {
      return null
    }

    const values = companyValues.results.slice(0, MAX_TOOLTIP_LIMIT)
    const total = companyValues.results.length

    return (
      <Tip id={id("company-values-tip", this.props)}>
        {values.map((c) => (
          <StyledTooltipContent key={c.uuid}>{maxLengthString({value: c.tag.toString(), length: 18})}</StyledTooltipContent>
        ))}
        {total > MAX_TOOLTIP_LIMIT && (
          <StyledTooltipContent>
            <FormattedMessage id="platform.customerValues.toolTipMore" values={{total: total - MAX_TOOLTIP_LIMIT}} />
          </StyledTooltipContent>
        )}
      </Tip>
    )
  }

  getCustomTags = () => {
    const {companyValues, formatMessage} = this.props
    const total = companyValues.results.length

    return [
      {
        archived: false,
        desc: "",
        icon: {alt: "", href: ""},
        name: formatMessage({id: "platform.customerValues.viewMore"}, {total}),
        tag: formatMessage({id: "platform.customerValues.viewMore"}, {total}),
        uuid: "platform.customerValues.viewMore"
      }
    ]
  }

  render() {
    const {companyValues, limit} = this.props
    if (
      !companyValues ||
      !companyValues.results ||
      !companyValues.results.length ||
      !companyValues.results.filter((value) => value.tag)?.length
    ) {
      return null
    }

    const values = companyValues.results.length > limit ? this.getCustomTags() : companyValues.results

    return (
      <FlexWrapper>
        <Tooltip id={id("company-values-tooltip", this.props)} placement="top" showMobile={false} tip={this.getTooltip()}>
          <StyledDiv>
            {values.map((companyValue) => (
              <CompanyValueTag companyValue={companyValue} key={companyValue.uuid} />
            ))}
          </StyledDiv>
        </Tooltip>
      </FlexWrapper>
    )
  }
}

export default injectIntl(CompanyValues)
